import { useEffect, useMemo } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { getMatchDetail, getPaginedMatchDetail } from "../../../../api/index.js";
import { GET_MATCH_DETAILS } from "../../../../constants/actionTypes.js";
import { MatchView } from "./MatchView.js";

const MatchResolver = () => {

    const { idMatch } = useParams();
    const dispatch = useDispatch()

    const {live, getIdMatchFromMatchName} = useOutletContext();

    const matchDetail = live.matchsDetails && live.matchsDetails.find(m => m.idMatch === idMatch);

    // Essaie de retirer la notion de matchComplete pour avoir + de precision sur le timer
    useEffect(() => {
      if(!idMatch)
        return
        
        const fetchMatchDetail = async () => {
          try {
            const response = await getMatchDetail(idMatch);
            dispatch({ type: GET_MATCH_DETAILS, payload: response.data})
              
          } catch (error) {
            console.error(error);
          }
        };
    
        fetchMatchDetail();
      }, [,dispatch, idMatch]);

    const loadMore = async () => {

      try {
        const response = await getPaginedMatchDetail(matchDetail.idMatch, matchDetail.pagination)
        dispatch({ type: GET_MATCH_DETAILS, payload: response.data})
          
      } catch (error) {
        console.error(error);
      }
    }

    if (!matchDetail || !matchDetail.isComplete) {
        return <CircularProgress />;
    }

    return (
      <Box>
        <Box className='medium-padding'></Box>
        <Box className='large-separator'></Box>
        <MatchView match={matchDetail} loadMore={loadMore} />
      </Box>
    )
}

export default MatchResolver